module.exports = __webpack_public_path__ + "static/img/暂无数据@2x.e8c5b13.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/暂无数据@2x.png
// module id = Fe76
// module chunks = 7